import { GridLayout } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import { ComponentFactory } from '@deity-io/di-data-flows-editor';
import { Box } from '@deity-io/portal-ui';
import { Collapsible } from 'components/Collapsible';
import { OUTPUT_PORT_COMPONENT_ID } from 'contracts/constants';
import type { FC } from 'react';
import FlowComponent from './FlowComponent';

interface AddFlowComponentPanelProps {
  isEditable: boolean;
  showProducers?: boolean;
  showPortsGroup?: boolean;
}
const AddFlowComponentPanel: FC<AddFlowComponentPanelProps> = ({
  isEditable,
  showProducers = true,
  showPortsGroup = false
}) => {
  const dragStart = (e: any, componentType: string) => {
    // calculate dragOffset (where the mousePointer is on the component compared to the upper left corner)
    const bounds = e.target.getBoundingClientRect();
    const offset = {
      x: e.clientX - bounds.x,
      y: e.clientY - bounds.y
    };
    e.dataTransfer.setData('componentType', componentType);
    e.dataTransfer.setData('dragOffset', JSON.stringify(offset));
  };

  const groups: Record<string, Array<any>> = {};
  mapRecordToArray(ComponentFactory.componentRepository, (comp, compKey) => {
    let group: Array<any>;
    if (comp.isProducer && !showProducers) {
      return undefined;
    }
    if (comp.category in groups) {
      group = groups[comp.category];
    } else {
      group = [];
      groups[comp.category] = group;
    }
    group.push(
      <FlowComponent
        key={compKey}
        icon={comp.icon}
        displayName={comp.displayName}
        category={comp.category}
        type={comp.type}
        description={comp.description}
        ports={comp.ports}
        isEditable={isEditable}
        // fnDragOver={dragOver}
        fnDragStart={e => dragStart(e, compKey)}
      />
    );
  });

  return (
    <Box sx={{ paddingRight: '15px' }}>
      {mapRecordToArray(groups, (components, group) => (
        <Collapsible key={`collapse_group_${group}`} title={group} collapsed={false} itemCount={components.length}>
          <GridLayout p="lg" gridTemplateColumns="1fr 1fr 1fr 1fr">
            {components}
          </GridLayout>
        </Collapsible>
      ))}

      {/** Add panel for virtual components, currently only flow output port */}
      {showPortsGroup && (
        <Collapsible key="collapse_group_ports" title="ports" collapsed={false} itemCount={1}>
          <GridLayout p="lg" gridTemplateColumns="1fr 1fr 1fr 1fr">
            <FlowComponent
              key={OUTPUT_PORT_COMPONENT_ID}
              icon=""
              displayName="Output port"
              category="ports"
              type="port"
              description="Output port for partial flows"
              ports={{}}
              isEditable={isEditable}
              fnDragStart={e => dragStart(e, OUTPUT_PORT_COMPONENT_ID)}
            />
          </GridLayout>
        </Collapsible>
      )}
    </Box>
  );
};

export default AddFlowComponentPanel;
